export const TAILWIND_SPACING = {
  "0": "0px",
  "3xs": "5px",
  "2xs": "clamp(0.5625rem, 0.5453rem + 0.0862vw, 0.625rem)",
  xs: "clamp(0.875rem, 0.8578rem + 0.0862vw, 0.9375rem)",
  sm: "clamp(1.125rem, 1.0905rem + 0.1724vw, 1.25rem)",
  md: "clamp(1.6875rem, 1.6358rem + 0.2586vw, 1.875rem)",
  base: "clamp(1.6875rem, 1.6358rem + 0.2586vw, 1.875rem)",
  lg: "clamp(2.25rem, 2.181rem + 0.3448vw, 2.5rem)",
  xl: "clamp(3.375rem, 3.2716rem + 0.5172vw, 3.75rem)",
  "2xl": "clamp(4.5rem, 4.3621rem + 0.6897vw, 5rem)",
  "3xl": "clamp(6.75rem, 6.5431rem + 1.0345vw, 7.5rem)",
  "4xl": "clamp(9rem, 8.7241rem + 1.3793vw, 10rem)",

  /* One-up pairs */
  "3xs-2xs": "clamp(0.3125rem, 0.2263rem + 0.431vw, 0.625rem)",
  "2xs-xs": "clamp(0.5625rem, 0.4591rem + 0.5172vw, 0.9375rem)",
  "xs-sm": "clamp(0.875rem, 0.7716rem + 0.5172vw, 1.25rem)",
  "sm-md": "clamp(1.125rem, 0.9181rem + 1.0345vw, 1.875rem)",
  "md-lg": "clamp(1.6875rem, 1.4634rem + 1.1207vw, 2.5rem)",
  "lg-xl": "clamp(2.25rem, 1.8362rem + 2.069vw, 3.75rem)",
  "xl-2xl": "clamp(3.375rem, 2.9267rem + 2.2414vw, 5rem)",
  "2xl-3xl": "clamp(4.5rem, 3.6724rem + 4.1379vw, 7.5rem)",
  "3xl-4xl": "clamp(6.75rem, 5.8534rem + 4.4828vw, 10rem)",
};
